import $ from 'jquery';
import { register_view_type } from '../lib/view_manager.js';
import * as filter_manager from '../lib/filter_manager.js';

register_view_type(
	'grid',
	{
		init( $view, args ) {
			let $container = $view.find('.js-gendernaut-grid');
			let $load_more = $view.find('.js-gendernaut-load-more');
			let $loading = $view.find('.js-gendernaut-loading');
			let page_size = $container.find('.js-gendernaut-item').length;

			let instance = this;

			instance.$container = $container;
			instance.$load_more = $load_more;
			instance.$loading = $loading;
			instance.page_size = page_size;
			instance.num_visible = page_size;
			instance.total_items = Infinity;
			instance.next_page_size = false;
			instance.$available = $();
			instance.$items_to_add = $();
			instance.last_loaded = false;
			instance.loading = false;
			instance.current_filters = false;

			$loading.hide();

			$container.gndr_isotope({
				itemSelector: '.js-gendernaut-item',
				layoutMode: 'fitRows',
			});
			$container.gndr_imagesLoaded().progress( function() {
				$container.gndr_isotope('layout');
			});
			$container.gndr_infiniteScroll({
				path: function(){
					let offset = this.loadCount * 100 + page_size;
					if ( offset < instance.total_items ) {
						return `${args.rest_url}gendernaut/v1/paging/${args.query}/grid/${offset}/100`;
					}
					return false;
				},
				responseBody: 'json',
				history: false,
				scrollThreshold: false,
			});

			$container.on( 'load.infiniteScroll', function( event, data ) {
				let $new_items = $(data.content).find('.js-gendernaut-item');
				instance.$available = instance.$available.add( $new_items );
				instance.total_items = data.total_items;
				instance.last_loaded = data.is_last_page;
				instance.loading = false;
			});

			$load_more.click(function(){
				instance.add_items();
			});
		},
		display( $view ) {
			this.$container.gndr_isotope('layout');
		},
		filter( $view, filters ) {
			let $container = this.$container;
			let instance = this;

			instance.current_filters = filters;

			$container.gndr_isotope( {
				filter: function() {
					return filter_manager.item_apply_filters( $(this), filters );
				}
			} );

			instance.num_visible = $container.gndr_isotope('getFilteredItemElements').length;
			if (instance.num_visible < instance.page_size) {
				instance.add_items();
			}
		},
		add_items() {
			const $container = this.$container;
			const instance = this;

			const page_size = instance.page_size;
			let num_visible = instance.num_visible;
			let next_page_size = instance.next_page_size;

			if ( ! next_page_size ) {
				instance.$load_more.attr('disabled', 'disabled');
				instance.$loading.show();
				next_page_size = num_visible + page_size - (num_visible % page_size);
			}
			
			while (num_visible < next_page_size && instance.$available.length) {
				const $new_items = instance.$available.slice(0, page_size);
				instance.$available = instance.$available.slice(page_size);

				if (instance.current_filters) {
					const $filtered = $new_items.filter(
						(i, e) => filter_manager.item_apply_filters( $(e), instance.current_filters )
					);
					num_visible += $filtered.length;
				}
				else {
					num_visible += $new_items.length;
				}

				instance.$items_to_add = instance.$items_to_add.add($new_items);
			}

			if (instance.last_loaded) {
				if (! instance.$available.length) {
					instance.$load_more.hide();
				}
			}
			else if (instance.$available.length < page_size) {
				instance.loading = $container.gndr_infiniteScroll('loadNextPage');

				if (num_visible < next_page_size) {
					instance.num_visible = num_visible;
					instance.next_page_size = next_page_size;

					instance.loading.then( instance.add_items.bind(instance) );
					return;
				}
			}

			$container.gndr_infiniteScroll('appendItems', instance.$items_to_add);
			$container.gndr_isotope('appended', instance.$items_to_add);
			instance.num_visible = $container.gndr_isotope('getFilteredItemElements').length;
			
			instance.$items_to_add = $();
			instance.next_page_size = false;
			instance.$load_more.attr('disabled', false);
			instance.$loading.hide();
		}
	}
);
